import React from "react";
import PropTypes from "prop-types";
import CandidateItem from "./CandidateItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsersSlash } from "@fortawesome/free-solid-svg-icons";

const CandidateList = ({ candidates, tenantId, jobUuid }) => {
  if (!candidates || candidates.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-center">
        <div className="w-16 h-16 rounded-full bg-slate-100 flex items-center justify-center mb-4">
          <FontAwesomeIcon icon={faUsersSlash} className="text-slate-400 text-xl" />
        </div>
        <h3 className="text-lg font-semibold text-slate-700 mb-1">Aucun candidat trouvé</h3>
        <p className="text-sm text-slate-500 max-w-sm">
          Aucun candidat ne correspond à vos filtres actuels. Essayez d'ajuster vos critères de recherche.
        </p>
      </div>
    );
  }

  return (
    <div className="mt-6 space-y-4">
      {candidates.map((candidate) => (
        <CandidateItem key={candidate.uuid} candidate={candidate} tenantId={tenantId} jobUuid={jobUuid} />
      ))}
    </div>
  );
};

CandidateList.propTypes = {
  candidates: PropTypes.array.isRequired,
  tenantId: PropTypes.string.isRequired,
  jobUuid: PropTypes.string.isRequired,
};

export default CandidateList;
